<template>
  <span class = "indicator">&#9679;</span>
</template>
<script>
export default {
  name : 'Indicator'
}
</script>
<style scoped>
.indicator {
  text-align: right;
  font-size: 12px;
};
</style>
